export default __webpack_public_path__ + "static/media/logo2.695ed1a3.png";